<app-dialog [title]=" 'version.about' | translate">

  <ng-container appDialogContent>
    <div class="app-font ">

      <h5 class="subheader">GUI: {{ guiVersion }}</h5>

      @if (version$ | async; as version) {

        @if (version.appVersion) {
          <h5 class="subheader">{{ 'version.application' | translate }}: {{ version.appVersion }}</h5>
        }

        @if (version.metrVersion || version.metrChecksum) {

          <mat-divider></mat-divider>

          @if (version.metrVersion) {
            <h5 class="subheader">{{ 'version.metrological' | translate }}: {{ version.metrVersion }}</h5>
          }

          @if (version.metrChecksum) {
            <h5>md5:{{ version.metrChecksum }}</h5>
          }

        }

      }

    </div>
  </ng-container>

</app-dialog>
